import Route from "vue-routisan";
import isAuthenticated from "../middlewares/isAuthenticated";
import isShipper from "@/http/routes/middlewares/isShipper";
import hasIntegraPermission from "@/http/routes/middlewares/hasPermission/hasIntegraPermission";
import userPermission from "@/util/valueObjects/userPermission";
// import hasLogisticAdvancedPlanOrBetter from "@/http/routes/middlewares/hasPlan/hasLogisticAdvancedPlanOrBetter";

const base = {
  meta: {
    visibilityPermission: [
      userPermission.INTEGRA_MANAGER__OWNER.value,
      userPermission.INTEGRA_MANAGER__ADMIN.value,
    ]
  }
};

const manager = {
  meta: {
    visibilityPermission: [
      userPermission.INTEGRA_MANAGER__OWNER.value,
      userPermission.INTEGRA_MANAGER__ADMIN.value,
    ]
  }
}

const quotationApprover = {
  meta: {
    visibilityPermission: [
      userPermission.INTEGRA_MANAGER__OWNER.value,
      userPermission.INTEGRA_MANAGER__ADMIN.value,
      userPermission.INTEGRA_MANAGER__QUOTATION_APPROVER_USER.value,
    ]
  }
}

const billing = {
  meta: {
    visibilityPermission: [
      userPermission.INTEGRA_MANAGER__OWNER.value,
      userPermission.INTEGRA_MANAGER__ADMIN.value,
      userPermission.BILLING__OWNER.value,
      userPermission.BILLING__ADMIN.value,
    ]
  }
}

const financier = {
  meta: {
    visibilityPermission: [
      userPermission.INTEGRA_MANAGER__OWNER.value,
      userPermission.INTEGRA_MANAGER__ADMIN.value,
      userPermission.INTEGRA_MANAGER__FINANCIER.value,
      userPermission.INTEGRA_MANAGER__FINANCIER_BASIC.value,
    ]
  }
}

const managerFinancier = {
  meta: {
    visibilityPermission: [
      userPermission.INTEGRA_MANAGER__OWNER.value,
      userPermission.INTEGRA_MANAGER__ADMIN.value,
      userPermission.INTEGRA_MANAGER__FINANCIER.value,
    ]
  }
};

const managerCommercial = {
  meta: {
    visibilityPermission: [
      userPermission.INTEGRA_MANAGER__OWNER.value,
      userPermission.INTEGRA_MANAGER__ADMIN.value,
      userPermission.INTEGRA_MANAGER__SHIPPER_COMMERCIAL.value,
    ]
  }
};

const orderAccess = {
  meta: {
    visibilityPermission: [
      userPermission.INTEGRA_MANAGER__OWNER.value,
      userPermission.INTEGRA_MANAGER__ADMIN.value,
      userPermission.INTEGRA_MANAGER__FINANCIER.value,
      userPermission.INTEGRA_MANAGER__SHIPPER_COMMERCIAL.value,
    ]
  }
};

Route.group({}, () => {
  Route.group({prefix: "logistic_manager", beforeEnter: [isAuthenticated, hasIntegraPermission]}, () => {

    Route.group({prefix: "shipper", beforeEnter: [isShipper]}, () => {

      Route.redirect("/", to => {
        return {name: "shipper.dashboard"};
      });

      Route.group({prefix: "notification"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/notification/NotificationList.vue")
        ).name("shipper.notification").options(manager);
      })

      Route.view("/demo", () =>
        import(/* webpackChunkName: "shipper" */ "@/resources/components/DemoPageMessage.vue")
      ).name("shipper.demo");

      Route.view("/dashboard", () =>
        import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/Dashboard/Dashboard.vue")
      ).name("shipper.dashboard").options(manager);

      Route.view("/control_tower", () =>
        import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/Dashboard/ControlTower.vue")
      ).name("shipper.control_tower").options(managerFinancier);

      Route.view("/order_in_progress", () =>
        import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/Dashboard/OrderInProgress.vue")
      ).name("shipper.order_in_progress").options(managerFinancier);

      Route.view("/wizard", () =>
        import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/wizard/Wizard")
      ).name("shipper.wizard")
        .options({
          meta: {
            layout: () =>
              import(/* webpackChunkName: "shipper" */ "@/resources/views/guest/layout/AuthLayout.vue")
          }
        });

      Route.view("/not_imported_files", () =>
        import(/* webpackChunkName: "shipper" */ "@/resources/components/InvoiceFiles/NotImportedFilesList")
      ).name("shipper.not_imported_files").options(manager);

      /*---------------------------------------------------------------------------------------------------------------
      |                                               BILLING                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "billing"}, () => {
        Route.view("/home", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/billing/BillingHome.vue")
        ).name("shipper.billing.home").options(billing);
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/billing/BillingList.vue")
        ).name("shipper.billing").options(billing);
        Route.view("/closing_day", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/billing/BillingClosingDay.vue")
        ).name("shipper.billing.closing_day").options(billing);
      });

      /*---------------------------------------------------------------------------------------------------------------
      |                                               QUOTES                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "quotes"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/order/OrderQuotes")
        ).name("shipper.order_quotes").options(quotationApprover);
        Route.view("/:id", () =>
          import(/* webpackChunkName: "v" */ "@/resources/views/logistic_manager/shipper/order/QuoteDetails")
        ).name("shipper.order_quotes_details").options(quotationApprover);
        Route.view("/transporters/:id", () =>
          import(/* webpackChunkName: "v" */ "@/resources/views/logistic_manager/shipper/order/QuoteDetailsTransporters")
        ).name("shipper.order_quotes_details_transporters").options(quotationApprover);
      });

      /*-------------------------------------------------------------------------------------------------------------
      |                                                   ORDER                                                     |
      --------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "order"}, () => {
        Route.group({}, () => {
          Route.view("/", () =>
            import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/order/OrderList")
          ).name("shipper.order").options(orderAccess);
          Route.view("/fob_order", () =>
            import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/fobOrder/FobOrder")
          ).name("shipper.fob_order").options(orderAccess);
          Route.view("/orders_documents", () =>
            import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/order/OrdersDocuments")
          ).name("shipper.orders_documents").options(manager);
          Route.view("/create", () =>
            import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/order/OrderCreate")
          ).name("shipper.order_create").options(manager);
          Route.view("/update/:id", () =>
            import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/order/OrderUpdate")
          ).name("shipper.order_update").options(managerFinancier);
          Route.view("/canceled", () =>
            import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/order/OrderCanceledList")
          ).name("shipper.order_canceled").options(manager);
          Route.view("/canceled/:id", () =>
            import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/order/OrderCanceledDetails")
          ).name("shipper.order_canceled_details").options(manager);
          Route.view("/occurrences", () =>
            import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/order/Occurrence")
          ).name("shipper.order_occurrences").options(orderAccess);
        });

        Route.view("/simulation", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/order/SimulationIntegra")
        ).name("shipper.order_simulation").options(manager);
        Route.view("/shipping_request_quote", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/order/ShippingRequestQuote")
        ).name("shipper.order_shipping_request_quote").options(quotationApprover);
        Route.view("/simulation/approve_table", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/order/SimulationIntegraApproveTable")
        ).name("shipper.simulation.approve_table").options(quotationApprover);
        Route.view("/approve_route_table", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/order/ApproveRouteTable")
        ).name("shipper.approve_route_table").options(quotationApprover);
      });

      /* --------------------------------------------------------------------------------------------------------------
      |                                                  EXPORT                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "export"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/export/OrderExport")
        ).name("shipper.order_export").options(manager);
        Route.view("/reports", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/export/OrderReport")
        ).name("shipper.order_reports").options(manager);

        Route.view("/requests", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/export/RequestExportView")
        ).name("shipper.request_export").options(manager);
        Route.view("/requests/reports", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/export/RequestReportView")
        ).name("shipper.request_reports").options(manager);

        Route.view("/orders_documents", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/export/OrdersDocumentsExport")
        ).name("shipper.orders_documents_export").options(manager);
        Route.view("/occurrences/reports", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/export/OccurrenceReportView")
        ).name("shipper.occurrence_reports").options(manager);
        Route.view("/transporters", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/export/TransportersExport")
        ).name("shipper.transporters_export").options(manager);
      });

      /* --------------------------------------------------------------------------------------------------------------
      |                                             PURCHASE ORDER                                                    |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "purchase_order"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/purchaseOrder/PurchaseOrderList")
        ).name("shipper.purchase_order").options(managerFinancier);
        Route.view("/create", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/purchaseOrder/PurchaseOrderCreate")
        ).name("shipper.purchase_order_create").options(managerFinancier);
        Route.view("/details/:id", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/purchaseOrder/PurchaseOrderDetails")
        ).name("shipper.purchase_order_details").options(managerFinancier);
        Route.view("/exports", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/export/PrePurchaseOrderReport")
        ).name("shipper.purchase_order_exports").options(managerFinancier);
        Route.view("/board", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/purchaseOrder/PurchaseOrderBoard")
        ).name("shipper.purchase_order_board").options(managerFinancier);
      });

      Route.group({prefix: "imports"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/import/ReportImport")
        ).name("shipper.imports").options(manager);;
      });

      /* --------------------------------------------------------------------------------------------------------------
      |                                               CUSTOMER                                                        |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "customer"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/customer/CustomerList")
        ).name("shipper.customer").options(manager);
        Route.view("/create", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/customer/CustomerCreate")
        ).name("shipper.customer_create").options(manager);
      });

      /*----------------------------------------------------------------------------------------------------------------
      |                                               SUBSIDIARY                                                        |
      -----------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "subsidiary"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/subsidiary/SubsidiaryList")
        ).name("shipper.subsidiary").options(manager);
        Route.view("/create", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/subsidiary/SubsidiaryCreate")
        ).name("shipper.subsidiary_create").options(manager);
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/subsidiary/SubsidiaryUpdate")
        ).name("shipper.subsidiary_update").options(manager);
      });

      /*---------------------------------------------------------------------------------------------------------------
       |                                               USERS                                                          |
       ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "user"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/user/UserList")
        ).name("shipper.user").options(manager);
        Route.view("/create", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/user/UserCreate")
        ).name("shipper.user_create").options(manager);
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/user/UserUpdate")
        ).name("shipper.user_update").options(manager);
      });

      Route.group({prefix: "invoice"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/invoice/CanhotoList")
        ).name("shipper.canhoto").options(financier);
        Route.view("/nf_files", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/invoice/NfList")
        ).name("shipper.nf_files").options(financier);
      });

      /* --------------------------------------------------------------------------------------------------------------
      |                                               CONFIGURATION                                                   |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "configuration"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/configuration/Configuration")
        ).name("shipper.configuration").options(manager);
        Route.view("/onboarding", () =>
          import(/* webpackChunkName: "auth" */ "@/resources/views/logistic_manager/shipper/configuration/FirstConfiguration/FirstConfiguration.vue")
        )
          .name("shipper.onboarding")
          .options({
            meta: {
              layout: () =>
                import(/* webpackChunkName: "guest" */ "src/resources/views/guest/layout/FinanceLayout.vue")
            }
          });
      })

      Route.group({prefix: "address"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/address/AddressAliasList")
        ).name("shipper.address_alias").options(manager);
        Route.view("/create", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/address/AddressAliasCreate")
        ).name("shipper.address_alias_create").options(manager);
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/address/AddressAliasUpdate")
        ).name("shipper.address_alias_update").options(manager);
      });

      Route.group({prefix: "transporter"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/transporters/TransporterList")
        ).name("shipper.transporter").options(manager);
        Route.view("/create", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/transporters/TransporterCreate")
        ).name("shipper.transporter_create").options(manager);
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/transporters/TransporterUpdate")
        ).name("shipper.transporter_update").options(manager);
      });


      Route.group({prefix: "supplier"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/supplier/SupplierList")
        ).name("shipper.supplier").options(manager);
        Route.view("/create", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/supplier/SupplierCreate")
        ).name("shipper.supplier_create").options(manager);
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/supplier/SupplierUpdate")
        ).name("shipper.supplier_update").options(manager);
      });

      Route.group({prefix: "company_user_create"}, () => {
        Route.view("/:id", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/subUser/SubUserCreate")
        ).name("shipper.sub_user_create").options(manager);
        Route.view("/:company_id/:id", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/subUser/SubUserUpdate")
        ).name("shipper.sub_user_update").options(manager);
      });

      /*---------------------------------------------------------------------------------------------------------------
      |                                               REQUEST                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "request"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/request/Request.vue")
        ).name("shipper.request").options(manager);
        Route.view("/import_nf", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/request/RequestImportNf.vue")
        ).name("shipper.request_import_nf").options(manager);
      });

      /*---------------------------------------------------------------------------------------------------------------
      |                                               Product                                                         |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "product"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/product/Product.vue")
        ).name("shipper.product").options(manager);
        Route.view("/create", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/components/Product/ProductCreate.vue")
        ).name("shipper.product_create").options(manager);
        Route.view("/update", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/components/Product/ProductUpdate.vue")
        ).name("shipper.product_update").options(manager);
      });

      Route.group({prefix: "picking"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/picking/PickingList.vue")
        ).name("shipper.picking").options(manager);
        Route.view("/details/:id", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/picking/PickingDetails.vue")
        ).name("shipper.picking_details").options(manager);
        Route.view("/control_tower", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/picking/PickingControlTower.vue")
        ).name("shipper.picking_control_tower").options(manager);
      });

      /*---------------------------------------------------------------------------------------------------------------
      |                                               ROAD MAP                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "road_map"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/roadMap/RoadMap.vue")
        ).name("shipper.road_map").options(manager);;
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/roadMap/RoadMapUpdate.vue")
        ).name("shipper.road_map_update").options(manager);;
      });

      Route.group({prefix: "final_customer"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/finalCustomer/FinalCustomerList")
        ).name("shipper.final_customer").options(managerCommercial);;
        Route.view("/create", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/finalCustomer/FinalCustomerCreate")
        ).name("shipper.final_customer_create").options(managerCommercial);;
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/finalCustomer/FinalCustomerUpdate")
        ).name("shipper.final_customer_update").options(managerCommercial);;
      });

      Route.group({prefix: "satisfaction_survey"}, () => {
        Route.view("/chart", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/satisfactionSurvey/SatisfactionSurveyResults.vue")
        ).name("shipper.satisfaction_survey_results").options(managerCommercial);
        Route.view("/answers", () =>
          import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/satisfactionSurvey/SatisfactionSurveyAnswers.vue")
        ).name("shipper.satisfaction_survey_answers").options(managerCommercial);
      });

      /*---------------------------------------------------------------------------------------------------------------
     |                                               Box                                                             |
     ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "box"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/shipper/boxes/BoxList.vue")
        ).name("shipper.box");
        Route.view("/create", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/shipper/boxes/BoxCreate.vue")
        ).name("shipper.box_create");
        Route.view("/update", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/shipper/boxes/BoxUpdate.vue")
        ).name("shipper.box_update");
      });
    });
  });
});

export default Route.all();
